/* ==========================================================================
   KINETIC TIME — RED BOLTRON · purchase controller
   Template: templates/page.mark-fairwhale-boltron-kinetic-time.liquid
   Markup: snippets/kt-boltron-purchase.liquid (+ -choice, -addon) and
           snippets/kt-boltron-sticky-bar.liquid

   Single source of commerce truth for the page. A namespaced copy of the
   FORM // FORCE controller (assets/ff-boltron-purchase.js), itself adapted
   from assets/roulette-feel-first-purchase.js (cart payload, gifts, busy
   lock, Buy it now). Visual state only through attributes / classes:
   [data-ktb-purchase][data-color] drives the per-colour atmosphere in CSS.

   Page contract (document events):
     ktb:request-variant { variantId, source }  → select it; ignored (with a
       re-emit of the current state) while busy or when the id is unknown;
       a no-op when it is already selected.
     ktb:variant-change { variantId, productId, color, label, available, price,
       compareAtPrice, priceHtml, compareHtml, discountPercent, image, source,
       initial }  ← after every selection, including the initial one.
   Live nodes (anywhere in #kt-boltron-page):
     [data-ktb-live="price|compare|label|availability|discount"]
   API: window.KTBoltronPurchase = { select(id, source), getState() }

   Cart: window.FairwhaleLandingCart.addItems(items, trigger) — it groups the
   gifts with the watch through window.FairwhaleCartAddons. Without it the
   native product form is submitted instead. ES2017, no dependencies.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-ktb-purchase]');
  if (!root || root.__ktbPurchaseInit) return;
  root.__ktbPurchaseInit = true;

  var page = document.getElementById('kt-boltron-page') || document;
  var toArray = function (list) {
    return Array.prototype.slice.call(list || []);
  };
  var $ = function (selector) {
    return root.querySelector(selector);
  };

  /* Optional per-page labels on the root (data-text-add / -adding / -sold-out);
     the Kinetic Time page sets none and keeps these defaults. */
  var TEXT = {
    add: root.getAttribute('data-text-add') || 'Add to cart',
    adding: root.getAttribute('data-text-adding') || 'Adding…',
    soldOut: root.getAttribute('data-text-sold-out') || 'Sold out',
    available: 'Available',
    error: 'Your selection could not be added. Please try again.',
    notReady: 'The cart is not ready yet. Please try again.'
  };

  /* ── Choices (one per colour; JSON from Liquid) ─────────────────────── */
  var choices = [];
  toArray(root.querySelectorAll('[data-ktb-purchase-choice]')).forEach(function (button) {
    try {
      var data = JSON.parse(button.getAttribute('data-choice'));
      if (!data || !data.id) return;
      data.button = button;
      data.id = Number(data.id);
      data.price = Number(data.price) || 0;
      data.compare = Number(data.compare) || 0;
      data.min = Math.max(1, Number(data.min) || 1);
      data.step = Math.max(1, Number(data.step) || 1);
      data.max = data.max == null || data.max === '' ? null : Number(data.max);
      data.available = data.available === true;
      choices.push(data);
    } catch (error) {
      /* A malformed option is skipped; the others keep working. */
    }
  });

  var form = $('.ktb-purchase__form');
  if (!form || !choices.length) return;

  var variantInput = form.querySelector('[data-ktb-selected-variant]');
  var quantityInput = form.querySelector('#ktb-quantity');
  var stepButtons = toArray(form.querySelectorAll('[data-ktb-qty-step]'));
  /* One pair in the form (Kinetic Time), or one pair per card linked with
     form="…" (editorial deck). A button with data-variant-id shows and buys
     that variant; without it, the selected one. */
  var atcButtons = toArray(root.querySelectorAll('[data-ktb-atc]'));
  var buyNowButtons = toArray(root.querySelectorAll('[data-ktb-buy-now]'));
  var errorNode = $('[data-ktb-error]');
  var statusNode = $('[data-ktb-purchase-status]');
  var stockNode = $('[data-ktb-purchase-stock]');
  var checkoutForm = $('[data-ktb-checkout-form]');
  var layers = toArray(root.querySelectorAll('[data-ktb-purchase-img]'));

  /* The Buy it now button submits natively without JavaScript (return_to).
     Here it becomes a plain button driven by purchase(true). */
  buyNowButtons.forEach(function (button) {
    button.type = 'button';
    button.removeAttribute('name');
    button.removeAttribute('value');
  });

  /* ── Add-ons (gifts start checked, paid add-ons unchecked) ──────────── */
  var addons = toArray(root.querySelectorAll('[data-ktb-addon]')).map(function (element) {
    var kind = element.getAttribute('data-kind') === 'gift' ? 'gift' : 'upsell';
    var toggle = element.querySelector('[data-ktb-addon-toggle]');
    var select = element.querySelector('[data-ktb-addon-variant]');
    var variantId = element.getAttribute('data-default-variant');
    var selected = kind === 'gift';
    if (toggle) toggle.checked = selected;
    if (select) select.value = variantId;
    return { element: element, kind: kind, toggle: toggle, select: select, variantId: variantId, selected: selected };
  });

  /* leaving: a checkout / native submit has started navigating away; the busy
     lock then stays on until the page is left (or restored from bfcache). */
  var state = { choice: null, quantity: 1, busy: false, nativeSubmit: false, leaving: false };

  function findChoice(id) {
    var key = Number(id);
    for (var i = 0; i < choices.length; i++) {
      if (choices[i].id === key) return choices[i];
    }
    return null;
  }

  function discountOf(choice) {
    if (!choice || !(choice.compare > choice.price) || choice.compare <= 0) return 0;
    return Math.round(((choice.compare - choice.price) * 100) / choice.compare);
  }

  function detailOf(choice, source, initial) {
    return {
      variantId: choice.id,
      productId: Number(choice.productId) || null,
      color: choice.color,
      label: choice.label,
      available: choice.available,
      price: choice.price,
      compareAtPrice: choice.compare,
      priceHtml: choice.priceHtml,
      compareHtml: choice.compare > choice.price ? choice.compareHtml : '',
      discountPercent: discountOf(choice),
      image: choice.image || null,
      source: source || 'purchase',
      initial: initial === true
    };
  }

  function emit(source, initial) {
    if (!state.choice) return;
    document.dispatchEvent(new CustomEvent('ktb:variant-change', { detail: detailOf(state.choice, source, initial) }));
  }

  /* ── Live nodes anywhere on the page ────────────────────────────────── */
  function each(selector, fn) {
    toArray(page.querySelectorAll(selector)).forEach(fn);
  }

  function syncLive(choice) {
    var hasCompare = choice.compare > choice.price;
    var discount = discountOf(choice);
    /* Always set innerHTML of our own wrapper: the Nova currency script may
       have replaced its text with span.money. */
    each('[data-ktb-live="price"]', function (node) {
      node.innerHTML = choice.priceHtml;
    });
    each('[data-ktb-live="compare"]', function (node) {
      node.innerHTML = hasCompare ? choice.compareHtml : '';
      node.hidden = !hasCompare;
    });
    each('[data-ktb-live-group="compare"]', function (node) {
      node.hidden = !hasCompare;
    });
    each('[data-ktb-live="label"]', function (node) {
      node.textContent = choice.label;
    });
    each('[data-ktb-live="availability"]', function (node) {
      node.textContent = choice.available ? TEXT.available : TEXT.soldOut;
      node.setAttribute('data-state', choice.available ? 'in' : 'out');
    });
    each('[data-ktb-live="discount"]', function (node) {
      node.textContent = discount > 0 ? 'Save ' + discount + '%' : '';
      node.hidden = !(discount > 0);
    });
    if (stockNode) stockNode.classList.toggle('is-sold-out', !choice.available);
  }

  function syncChoices() {
    choices.forEach(function (choice) {
      var selected = choice === state.choice;
      choice.button.setAttribute('aria-checked', selected ? 'true' : 'false');
      choice.button.tabIndex = selected ? 0 : -1;
      choice.button.classList.toggle('is-selected', selected);
      choice.button.setAttribute('aria-disabled', state.busy ? 'true' : 'false');
    });
  }

  function syncMedia(color) {
    var hasLayer = layers.some(function (layer) {
      return layer.getAttribute('data-ktb-purchase-img') === color;
    });
    layers.forEach(function (layer) {
      var active = hasLayer ? layer.getAttribute('data-ktb-purchase-img') === color : layer === layers[0];
      layer.classList.toggle('is-active', active);
      if (active) layer.removeAttribute('aria-hidden');
      else layer.setAttribute('aria-hidden', 'true');
    });
  }

  function choiceOf(button) {
    return findChoice(button.getAttribute('data-variant-id')) || state.choice;
  }

  function syncButtons() {
    atcButtons.forEach(function (button) {
      var choice = choiceOf(button);
      var available = !!(choice && choice.available);
      var adding = state.busy && choice === state.choice;
      var label = button.querySelector('[data-ktb-atc-label]') || button;
      button.disabled = state.busy || !available;
      button.setAttribute('aria-busy', adding ? 'true' : 'false');
      label.textContent = adding ? TEXT.adding : available ? TEXT.add : TEXT.soldOut;
    });
    buyNowButtons.forEach(function (button) {
      var choice = choiceOf(button);
      button.disabled = state.busy || !(choice && choice.available);
      button.setAttribute('aria-busy', state.busy && choice === state.choice ? 'true' : 'false');
    });
    if (quantityInput) quantityInput.disabled = state.busy;
    stepButtons.forEach(function (button) {
      var down = Number(button.getAttribute('data-ktb-qty-step')) < 0;
      var choice = state.choice;
      var atLimit = down
        ? state.quantity <= (choice ? choice.min : 1)
        : !!(choice && choice.max != null && state.quantity + choice.step > choice.max);
      button.disabled = state.busy || atLimit;
    });
    root.classList.toggle('is-busy', state.busy);
    syncChoices();
    syncAddons();
  }

  /* Clamp to the variant's quantity rule: min, max, increment. */
  function setQuantity(value) {
    var choice = state.choice;
    var min = choice ? choice.min : 1;
    var step = choice ? choice.step : 1;
    var max = choice ? choice.max : null;
    var next = Math.max(min, isFinite(value) && value > 0 ? Math.floor(value) : min);
    if (max != null && max >= min) next = Math.min(next, max);
    state.quantity = min + Math.floor((next - min) / step) * step;
    if (quantityInput) {
      quantityInput.value = String(state.quantity);
      quantityInput.min = String(min);
      quantityInput.step = String(step);
      if (max != null) quantityInput.max = String(max);
      else quantityInput.removeAttribute('max');
    }
    syncButtons();
  }

  function syncAddons() {
    addons.forEach(function (addon) {
      if (addon.toggle) {
        addon.toggle.checked = addon.selected;
        addon.toggle.disabled = state.busy;
      }
      if (addon.select) addon.select.disabled = state.busy;
      addon.element.classList.toggle('is-checked', addon.selected);
    });
  }

  function syncAddonPrice(addon) {
    if (!addon.select || addon.kind !== 'upsell') return;
    var option = addon.select.options[addon.select.selectedIndex];
    if (!option) return;
    var price = addon.element.querySelector('[data-ktb-addon-price]');
    var compare = addon.element.querySelector('[data-ktb-addon-compare]');
    var compareLabel = addon.element.querySelector('[data-ktb-addon-compare-label]');
    var compareHtml = option.getAttribute('data-compare') || '';
    if (price) price.innerHTML = option.getAttribute('data-price') || '';
    if (compare) {
      compare.innerHTML = compareHtml;
      compare.hidden = !compareHtml;
    }
    if (compareLabel) compareLabel.hidden = !compareHtml;
  }

  function hideError() {
    if (!errorNode) return;
    errorNode.hidden = true;
    errorNode.textContent = '';
  }

  function showError(message) {
    if (!errorNode) return;
    errorNode.textContent = message || TEXT.error;
    errorNode.hidden = false;
  }

  function updateUrl(choice) {
    if (!window.history || typeof window.history.replaceState !== 'function') return;
    try {
      var url = new URL(window.location.href);
      if (url.searchParams.get('variant') === String(choice.id)) return;
      url.searchParams.set('variant', String(choice.id));
      window.history.replaceState(window.history.state, '', url.toString());
    } catch (error) {
      /* URL API unavailable: keep the address as it is. */
    }
  }

  /* ── Selection ──────────────────────────────────────────────────────── */
  function applyChoice(choice, source, initial) {
    state.choice = choice;
    root.setAttribute('data-variant-id', String(choice.id));
    root.setAttribute('data-color', choice.color);
    if (choice.productId) root.setAttribute('data-product-id', String(choice.productId));
    if (variantInput) variantInput.value = String(choice.id);

    syncLive(choice);
    syncMedia(choice.color);
    syncSticky(choice.color);
    setQuantity(quantityInput ? Number(quantityInput.value) : state.quantity);
    hideError();

    if (!initial) {
      if (statusNode) statusNode.textContent = choice.label + ' selected.' + (choice.available ? '' : ' ' + TEXT.soldOut + '.');
      updateUrl(choice);
    }
    emit(source, initial);
  }

  /* Returns true when the requested variant is (now) the selection. */
  function select(id, source) {
    var choice = findChoice(id);
    if (!choice || state.busy) {
      emit('purchase', false);
      return false;
    }
    if (choice === state.choice) return true;
    applyChoice(choice, source || 'purchase', false);
    return true;
  }

  /* Radio group: click selects; arrows / Home / End move focus and select. */
  choices.forEach(function (choice, index) {
    choice.button.addEventListener('click', function () {
      select(choice.id, 'purchase');
    });
    choice.button.addEventListener('keydown', function (event) {
      var key = event.key;
      var next = null;
      if (key === 'ArrowRight' || key === 'ArrowDown') next = choices[(index + 1) % choices.length];
      else if (key === 'ArrowLeft' || key === 'ArrowUp') next = choices[(index - 1 + choices.length) % choices.length];
      else if (key === 'Home') next = choices[0];
      else if (key === 'End') next = choices[choices.length - 1];
      else if (key === ' ' || key === 'Enter') {
        event.preventDefault();
        select(choice.id, 'purchase');
        return;
      }
      if (!next) return;
      event.preventDefault();
      if (state.busy) return;
      select(next.id, 'purchase');
      next.button.focus();
    });
  });

  document.addEventListener('ktb:request-variant', function (event) {
    var detail = event.detail || {};
    select(detail.variantId, detail.source || 'external');
  });

  /* ── Quantity ───────────────────────────────────────────────────────── */
  stepButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      if (state.busy) return;
      var direction = Number(button.getAttribute('data-ktb-qty-step')) < 0 ? -1 : 1;
      var step = state.choice ? state.choice.step : 1;
      setQuantity(state.quantity + direction * step);
    });
  });
  if (quantityInput) {
    quantityInput.addEventListener('change', function () {
      setQuantity(Number(quantityInput.value));
    });
  }

  /* ── Add-on toggles ─────────────────────────────────────────────────── */
  root.addEventListener('change', function (event) {
    var element = event.target.closest ? event.target.closest('[data-ktb-addon]') : null;
    if (!element || state.busy) return;
    var addon = null;
    for (var i = 0; i < addons.length; i++) {
      if (addons[i].element === element) addon = addons[i];
    }
    if (!addon) return;
    if (event.target === addon.toggle) addon.selected = addon.toggle.checked;
    if (event.target === addon.select) {
      addon.variantId = addon.select.value;
      syncAddonPrice(addon);
    }
    syncAddons();
  });

  /* ── Cart ───────────────────────────────────────────────────────────── */
  function cartItems() {
    var items = [{ id: state.choice.id, quantity: state.quantity }];
    var seen = {};
    seen[String(state.choice.id)] = true;
    addons.forEach(function (addon) {
      var id = String(addon.variantId || '');
      if (!addon.selected || !id || seen[id]) return;
      seen[id] = true;
      items.push({
        id: Number(id),
        quantity: 1,
        properties: { _addon_kind: addon.kind === 'gift' ? 'free_gift' : 'paid_addon' }
      });
    });
    return items;
  }

  function submitCheckout() {
    if (!checkoutForm) {
      window.location.href = '/checkout';
      return;
    }
    var button = checkoutForm.querySelector('[name="checkout"]');
    if (typeof checkoutForm.requestSubmit === 'function') {
      checkoutForm.requestSubmit(button || undefined);
      return;
    }
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'checkout';
    input.value = 'checkout';
    checkoutForm.appendChild(input);
    checkoutForm.submit();
  }

  /* The return_to input submitNative(true) injects into the product form. */
  function removeInjectedRedirect() {
    toArray(form.querySelectorAll('input[data-ktb-return-to]')).forEach(function (input) {
      if (input.parentNode) input.parentNode.removeChild(input);
    });
  }

  /* No landing cart drawer on the page: the native product form adds the watch. */
  function submitNative(checkout) {
    state.nativeSubmit = true;
    state.leaving = true;
    state.busy = true;
    syncButtons();
    if (variantInput) variantInput.value = String(state.choice.id);
    if (quantityInput) {
      /* syncButtons() disables it while busy; a disabled input is not posted. */
      quantityInput.disabled = false;
      quantityInput.value = String(state.quantity);
    }
    removeInjectedRedirect();
    if (checkout) {
      var redirect = document.createElement('input');
      redirect.type = 'hidden';
      redirect.name = 'return_to';
      redirect.value = '/checkout';
      redirect.setAttribute('data-ktb-return-to', '');
      form.appendChild(redirect);
    }
    form.submit();
  }

  function restoreFocus(trigger) {
    var active = document.activeElement;
    if (trigger && trigger.isConnected && (!active || active === document.body || active === trigger)) {
      try {
        trigger.focus({ preventScroll: true });
      } catch (error) {
        trigger.focus();
      }
    }
  }

  async function purchase(checkout, trigger) {
    if (state.busy || !state.choice || !state.choice.available) return;
    setQuantity(quantityInput ? Number(quantityInput.value) : state.quantity);
    var cart = window.FairwhaleLandingCart;
    if (!cart || typeof cart.addItems !== 'function') {
      submitNative(checkout);
      return;
    }
    hideError();
    state.busy = true;
    syncButtons();
    var failed = false;
    try {
      await cart.addItems(cartItems(), trigger);
      if (checkout) {
        /* Navigation to checkout starts: keep the lock so nothing can be
           changed or added twice while the next page loads. */
        state.leaving = true;
        submitCheckout();
      }
    } catch (exception) {
      failed = true;
      state.leaving = false;
      showError((exception && exception.message) || TEXT.error);
    } finally {
      if (!state.leaving) {
        state.busy = false;
        syncButtons();
      }
      if (failed) restoreFocus(trigger);
    }
  }

  /* A per-variant button buys its own variant (a no-op when already selected). */
  function follow(button) {
    var id = button && button.getAttribute('data-variant-id');
    if (id) select(id, 'purchase');
  }

  form.addEventListener('submit', function (event) {
    if (state.nativeSubmit) return;
    event.preventDefault();
    var trigger = event.submitter && atcButtons.indexOf(event.submitter) > -1 ? event.submitter : atcButtons[0] || null;
    follow(trigger);
    purchase(false, trigger);
  });
  buyNowButtons.forEach(function (button) {
    button.addEventListener('click', function (event) {
      event.preventDefault();
      if (button.disabled) return;
      follow(button);
      purchase(true, button);
    });
  });
  /* A page restored from the back/forward cache must be usable again. */
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    state.nativeSubmit = false;
    state.leaving = false;
    state.busy = false;
    removeInjectedRedirect();
    syncButtons();
  });

  /* ── Sticky bar ─────────────────────────────────────────────────────── */
  var sticky = document.querySelector('[data-ktb-sticky]');
  var stickyThumbs = sticky ? toArray(sticky.querySelectorAll('[data-ktb-sticky-thumb]')) : [];

  function syncSticky(color) {
    if (sticky) sticky.setAttribute('data-color', color);
    if (!stickyThumbs.length) return;
    var match = stickyThumbs.some(function (thumb) {
      return thumb.getAttribute('data-ktb-sticky-thumb') === color;
    });
    stickyThumbs.forEach(function (thumb) {
      var key = thumb.getAttribute('data-ktb-sticky-thumb');
      thumb.classList.toggle('is-active', match ? key === color : key === 'red');
    });
  }

  function initSticky() {
    if (!sticky) return;
    var hero = document.getElementById('ktb-hero');
    var heroPast = null;
    var blocked = null;

    function update() {
      var show = heroPast && !blocked;
      if (!show && sticky.contains(document.activeElement)) {
        try {
          document.activeElement.blur();
        } catch (error) {
          /* ignore */
        }
      }
      sticky.classList.toggle('is-visible', show);
      if (show) sticky.removeAttribute('inert');
      else sticky.setAttribute('inert', '');
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
    }

    /* Two rect reads per frame at most. Shown once the hero has left the
       viewport upwards; blocked from the moment the top of #ktb-purchase (the
       root) enters the viewport, and for everything below it, so the bar never
       comes back over reassurance, specs or the close. Rect tests (not an
       IntersectionObserver) also cover jumps: a restored scroll position or
       an anchor that skips a section entirely. */
    var frame = 0;
    function measure() {
      frame = 0;
      var past = hero ? hero.getBoundingClientRect().bottom <= 0 : true;
      var below = root.getBoundingClientRect().top < window.innerHeight;
      if (past === heroPast && below === blocked) return;
      heroPast = past;
      blocked = below;
      update();
    }
    function schedule() {
      if (!frame) frame = window.requestAnimationFrame(measure);
    }
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('load', schedule);
    /* Layout above the purchase module can still move (lazy media, fonts). */
    if ('ResizeObserver' in window) new ResizeObserver(schedule).observe(document.body);
    measure();
  }

  /* ── Public API ─────────────────────────────────────────────────────── */
  window.KTBoltronPurchase = {
    select: function (id, source) {
      return select(id, source || 'api');
    },
    getState: function () {
      if (!state.choice) return null;
      var detail = detailOf(state.choice, 'state', false);
      detail.quantity = state.quantity;
      detail.busy = state.busy;
      return detail;
    }
  };

  /* ── Initial selection: ?variant → data-default-variant → first available → first ── */
  function initialChoice() {
    var fromUrl = null;
    try {
      fromUrl = new URL(window.location.href).searchParams.get('variant');
    } catch (error) {
      fromUrl = null;
    }
    return (
      (fromUrl && findChoice(fromUrl)) ||
      findChoice(root.getAttribute('data-default-variant')) ||
      choices.filter(function (choice) {
        return choice.available;
      })[0] ||
      choices[0]
    );
  }

  initSticky();
  applyChoice(initialChoice(), 'initial', true);
})();
